import BaseView from "scripts/views/baseView";
import {
  redirectToFragment,
  getCurrentFragment,
} from "scripts/utils/routerHelpers";

import templateSearchOverlayMenuView from "templates/searchOverlayMenu.hbs";

class SearchOverlayMenuView extends BaseView {
  get template() {
    return templateSearchOverlayMenuView;
  }

  get events() {
    return {
      "keydown #bb-search-overlay-menu-search-input": "handleKeyDown",
      "click #bb-search-overlay-menu-search-button": "goSearchResults",
    };
  }

  render() {
    this.$el.html(this.template());

    return this;
  }

  handleKeyDown(event) {
    // Enter key pressed with search terms
    if (event.which === 13) {
      this.goSearchResults();
    }
  }

  goSearchResults() {
    const $input = $("#bb-search-overlay-menu-search-input");
    const query = $input.val();

    if (query) {
      $input.blur();

      const urlFragment = `search-results/${encodeURIComponent(
        "g=" + encodeURIComponent(query),
      )}`;

      if (getCurrentFragment() === urlFragment) {
        this.trigger("close");
      } else {
        redirectToFragment(urlFragment);
      }
    }
  }

  focus() {
    $("#bb-search-overlay-menu-search-input").focus();
  }

  clear() {
    $("#bb-search-overlay-menu-search-input").val("");
  }

  setSearchTerm(searchTerm) {
    $("#bb-search-overlay-menu-search-input").val(searchTerm);
  }

  close() {
    super.close();
    $(document).off("keydown");
  }
}

export default SearchOverlayMenuView;
